export enum EnumMessageRole {
  USER = 'user',
  AGENT = 'agent'
}
